package at.theatervogelweide.admin.web.components

import androidx.compose.runtime.Composable
import kotlinx.browser.document
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Nav
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLElement

private val index = Bem("admin-section-index")

/** A section card of a long editor: [id] is the card's id, [count] e.g. its number of performances. */
data class IndexedSection(val id: String, val label: String, val count: Int? = null)

/**
 * The jump list beside the section cards of a long editor, with the record's delete action in [footer]. Jumping
 * scrolls to the card and moves the focus there without touching the address, which the router owns.
 */
@Composable
fun AdminSectionIndex(sections: List<IndexedSection>, footer: (@Composable () -> Unit)? = null) {
    Nav({
        classes(index.block)
        attr("aria-label", "Abschnitte")
    }) {
        sections.forEach { section ->
            A("#${section.id}", {
                classes(index.element("link").className)
                onClick { event ->
                    event.preventDefault()
                    (document.getElementById(section.id) as? HTMLElement)?.let { target ->
                        target.scrollIntoView()
                        // the card itself isn't focusable; its title is the start of the section for screen readers
                        target.setAttribute("tabindex", "-1")
                        target.focus()
                    }
                }
            }) {
                Text(section.label)
                section.count?.let { count ->
                    Span({ classes(index.element("count").className) }) { Text(count.toString()) }
                }
            }
        }
        footer?.let {
            Div({ classes(index.element("footer").className) }) { it() }
        }
    }
}
